<template lang="pug">
    main.nosotras.contenedor.pt110      
      prismic-rich-text(:field="data.contenido")


</template>
<script>
import Citas from '@/components/Citas.vue' 
import SaberMas from '@/components/SaberMas.vue' 
import Preguntas from '@/components/PreguntasFrecuentes.vue'

export default {
    name: 'nosotras',
    components: {
        Citas,
        SaberMas,
        Preguntas
    }, 
    data() {
        return {
            data: [],
            uid: this.$route.params.id
        }
    },
    methods: {
        getContent () {
        this.$prismic.client.getByUID("legales", this.$route.params.id)
          .then(response => {
            this.data = response.data
          });
        }
    },
    created() {
        this.getContent();
    }
    
}
</script>
<style lang="sass">
.comunidad
  img 
    width: 100%
    max-width: 450px
    margin: 0 auto
.sin-under
  text-decoration: none
  display: inline-block
  margin-top: 30px
</style>
